"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductSchema = void 0;
const joi_1 = __importDefault(require("joi"));
exports.ProductSchema = joi_1.default.object({
    createdAt: joi_1.default.date().required(),
    updatedAt: joi_1.default.date().required(),
    salesforceId: joi_1.default.string().required(),
    tags: joi_1.default.array().items(joi_1.default.string()).required(),
    // FIXME: hundreds of products without skills
    skills: joi_1.default.array().items(joi_1.default.string()),
    // FIXME: hundreds of products without skills
    equipment: joi_1.default.array().items(joi_1.default.string()),
    description: joi_1.default.string(),
    duration: joi_1.default.number().required(),
    uuid: joi_1.default.string().uuid().required(),
    sortIndex: joi_1.default.number().allow(null),
    realCapacitiesOnly: joi_1.default.boolean(),
    isActive: joi_1.default.boolean().required(),
    deleted: joi_1.default.boolean(),
    // FIXME, we have products without it
    customerSalesforceId: joi_1.default.string(),
    shotByOwner: joi_1.default.bool().allow(null),
    image: joi_1.default.string().uri().allow(null),
    name: joi_1.default.string(),
    price: joi_1.default.object({
        amount: joi_1.default.number(),
        currency: joi_1.default.string()
    }),
    internalWalkVideo: joi_1.default.boolean(),
    proWalkVideo: joi_1.default.boolean(),
    renamingSpecs: joi_1.default.string().allow(null, ''),
    photosMin: joi_1.default.number().allow(null),
    photosMax: joi_1.default.number().allow(null),
    clientSpecificGuidelines: joi_1.default.string().allow(null),
    videoBrief: joi_1.default.string().allow(null),
    modelRelease: joi_1.default.string().allow(null),
    excludeRiskyPhotographers: joi_1.default.boolean(),
    otherVideoRequired: joi_1.default.boolean(),
    // TODO: make it required after migration
    organizationUuid: joi_1.default.string().uuid()
}).meta({ className: 'Product' });
//# sourceMappingURL=ProductSchema.js.map